import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { getFromStorage, setInStorage } from "../utils/storage";
import MailIcon from "@material-ui/icons/Mail";
import PersonIcon from "@material-ui/icons/People";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockIcon from "@material-ui/icons/Lock";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

const formStyle = {
  display: "flex",
  flexDirection: "column",
  width: "80%",
};

const inputStyle = {
  marginBottom: "20px",
};

const LoginPage = ({ setToken }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const login = () => {
    axios
      .post("https://bb-exchange.herokuapp.com/api/account/signin", {
        email: email,
        password: password,
      })
      .then(function (response) {
        if (response.data.success) {
          setToken(response.data.token);
        } else {
          setNotificationMessage(response.data.message);
          setNotificationSeverity("error");
          setOpenNotification(true);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        width: "500px",
        borderRadius: "10px",
        paddingTop: "20px",
        paddingBottom: "40px",
      }}
    >
      <h1 style={{ marginTop: "0px" }}>Login</h1>
      <form noValidate autoComplete="off" style={formStyle}>
        <TextField
          id="standard-basic"
          label="Email"
          variant="outlined"
          style={inputStyle}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MailIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          id="standard-basic"
          label="Password"
          variant="outlined"
          style={inputStyle}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          color="primary"
          style={{ maxWidth: "500px" }}
          onClick={login}
        >
          Login
        </Button>
      </form>
      <Snackbar
        open={openNotification}
        autoHideDuration={6000}
        onClose={() => setOpenNotification(false)}
      >
        <Alert
          onClose={() => setOpenNotification(false)}
          severity={notificationSeverity}
        >
          {notificationMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default LoginPage;
